// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"DocModal_fullscreen__a-dQE"};